import { ApiManager } from '@11za/app/core/utilities/api-manager';
import { apiEndpoints } from '@11za/app/core/constants/api-endpoints';
import { Injectable } from '@angular/core';
import { ResponseModel } from '@11za/app/core/utilities/response-model';

@Injectable({
  providedIn: 'root'
})
export class QueueService {
  constructor(private apiManager: ApiManager) { }

  public getQueuedCustomersCount = async (): Promise<ResponseModel> => {
    return this.apiManager.request({ url: apiEndpoints.QUEUE_CUSTOMER_COUNT, method: 'POST' }, {}, [], false)
  }

  public queueChats = async (data: any): Promise<ResponseModel> => {
    return this.apiManager.request({ url: apiEndpoints.QUEUE_CHATS, method: 'POST' }, data)
  }

  public getTeamMembers = async (): Promise<ResponseModel> => {
    return this.apiManager.request({ url: apiEndpoints.SETTINGS_TEAM_MEMBERS, method: 'POST' }, {})
  }
  public roundRobinMember = async (): Promise<ResponseModel> => {
    return this.apiManager.request({ url: apiEndpoints.ROUND_ROBIN_MEMBER, method: 'POST' }, {})
  }
   public chatAssignToRound = async (payload : any): Promise<ResponseModel> => {
    return this.apiManager.request({ url: apiEndpoints.CHAT_ASSIGN_TO_ROUND, method: 'POST' }, payload)
  }

  public getTeams = async (): Promise<ResponseModel> => {
    return this.apiManager.request({ url: apiEndpoints.CHAT_ROUTERS_TEAMS, method: 'POST' }, {})
  }

  public getQueueChatAssign = async (): Promise<ResponseModel> => {
    return this.apiManager.request({ url: apiEndpoints.QUEUE_GET_CHAT_ASSIGN, method: 'POST' }, {})
  }

  public getChatRouterTeamMembers = async (data: any): Promise<ResponseModel> => {
    return this.apiManager.request({ url: apiEndpoints.CHAT_ROUTERS_TEAM_MEMBERS, method: 'POST' }, data)
  }

  public setChatAssignTo = async (data: any): Promise<ResponseModel> => {
    return this.apiManager.request({ url: apiEndpoints.SETTINGS_CHAT_ASSIGN_TO, method: 'POST' }, data)
  }
  public assignChatToMe = async (data: any): Promise<ResponseModel> => {
    return this.apiManager.request({ url: apiEndpoints.ASSIGN_CHAT_TO_ME, method: 'POST' }, data)
  }


}
